"use strict";
// THIS FILE IS GENERATED AUTOMATICALLY. DO NOT MODIFY.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryClient = exports.txClient = exports.registry = exports.MissingWalletError = void 0;
var stargate_1 = require("@cosmjs/stargate");
var proto_signing_1 = require("@cosmjs/proto-signing");
var rest_1 = require("./rest");
var tx_1 = require("./types/nftoracle/tx");
var tx_2 = require("./types/nftoracle/tx");
var tx_3 = require("./types/nftoracle/tx");
var tx_4 = require("./types/nftoracle/tx");
var tx_5 = require("./types/nftoracle/tx");
var tx_6 = require("./types/nftoracle/tx");
var tx_7 = require("./types/nftoracle/tx");
var tx_8 = require("./types/nftoracle/tx");
var tx_9 = require("./types/nftoracle/tx");
var tx_10 = require("./types/nftoracle/tx");
var types = [
    ["/thesixnetwork.sixnft.nftoracle.MsgDeleteActionSigner", tx_1.MsgDeleteActionSigner],
    ["/thesixnetwork.sixnft.nftoracle.MsgCreateVerifyCollectionOwnerRequest", tx_2.MsgCreateVerifyCollectionOwnerRequest],
    ["/thesixnetwork.sixnft.nftoracle.MsgCreateActionRequest", tx_3.MsgCreateActionRequest],
    ["/thesixnetwork.sixnft.nftoracle.MsgSubmitMintResponse", tx_4.MsgSubmitMintResponse],
    ["/thesixnetwork.sixnft.nftoracle.MsgCreateActionSigner", tx_5.MsgCreateActionSigner],
    ["/thesixnetwork.sixnft.nftoracle.MsgSubmitActionResponse", tx_6.MsgSubmitActionResponse],
    ["/thesixnetwork.sixnft.nftoracle.MsgUpdateActionSigner", tx_7.MsgUpdateActionSigner],
    ["/thesixnetwork.sixnft.nftoracle.MsgSetMinimumConfirmation", tx_8.MsgSetMinimumConfirmation],
    ["/thesixnetwork.sixnft.nftoracle.MsgCreateMintRequest", tx_9.MsgCreateMintRequest],
    ["/thesixnetwork.sixnft.nftoracle.MsgSubmitVerifyCollectionOwner", tx_10.MsgSubmitVerifyCollectionOwner],
];
exports.MissingWalletError = new Error("wallet is required");
exports.registry = new proto_signing_1.Registry(types);
var defaultFee = {
    amount: [],
    gas: "200000",
};
var txClient = function (wallet, _a, options) {
    var _b = _a === void 0 ? { addr: "http://localhost:26657" } : _a, addr = _b.addr;
    return __awaiter(void 0, void 0, void 0, function () {
        var client, address;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!wallet)
                        throw exports.MissingWalletError;
                    if (!addr) return [3 /*break*/, 2];
                    return [4 /*yield*/, stargate_1.SigningStargateClient.connectWithSigner(addr, wallet, __assign({ registry: exports.registry }, options))];
                case 1:
                    client = _c.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, stargate_1.SigningStargateClient.offline(wallet, { registry: exports.registry })];
                case 3:
                    client = _c.sent();
                    _c.label = 4;
                case 4: return [4 /*yield*/, wallet.getAccounts()];
                case 5:
                    address = (_c.sent())[0].address;
                    return [2 /*return*/, {
                            signAndBroadcast: function (msgs, _a) {
                                var _b = _a === void 0 ? { fee: defaultFee, memo: "" } : _a, fee = _b.fee, memo = _b.memo;
                                return client.signAndBroadcast(address, msgs, fee, memo);
                            },
                            msgDeleteActionSigner: function (data) { return ({ typeUrl: "/thesixnetwork.sixnft.nftoracle.MsgDeleteActionSigner", value: tx_1.MsgDeleteActionSigner.fromPartial(data) }); },
                            msgCreateVerifyCollectionOwnerRequest: function (data) { return ({ typeUrl: "/thesixnetwork.sixnft.nftoracle.MsgCreateVerifyCollectionOwnerRequest", value: tx_2.MsgCreateVerifyCollectionOwnerRequest.fromPartial(data) }); },
                            msgCreateActionRequest: function (data) { return ({ typeUrl: "/thesixnetwork.sixnft.nftoracle.MsgCreateActionRequest", value: tx_3.MsgCreateActionRequest.fromPartial(data) }); },
                            msgSubmitMintResponse: function (data) { return ({ typeUrl: "/thesixnetwork.sixnft.nftoracle.MsgSubmitMintResponse", value: tx_4.MsgSubmitMintResponse.fromPartial(data) }); },
                            msgCreateActionSigner: function (data) { return ({ typeUrl: "/thesixnetwork.sixnft.nftoracle.MsgCreateActionSigner", value: tx_5.MsgCreateActionSigner.fromPartial(data) }); },
                            msgSubmitActionResponse: function (data) { return ({ typeUrl: "/thesixnetwork.sixnft.nftoracle.MsgSubmitActionResponse", value: tx_6.MsgSubmitActionResponse.fromPartial(data) }); },
                            msgUpdateActionSigner: function (data) { return ({ typeUrl: "/thesixnetwork.sixnft.nftoracle.MsgUpdateActionSigner", value: tx_7.MsgUpdateActionSigner.fromPartial(data) }); },
                            msgSetMinimumConfirmation: function (data) { return ({ typeUrl: "/thesixnetwork.sixnft.nftoracle.MsgSetMinimumConfirmation", value: tx_8.MsgSetMinimumConfirmation.fromPartial(data) }); },
                            msgCreateMintRequest: function (data) { return ({ typeUrl: "/thesixnetwork.sixnft.nftoracle.MsgCreateMintRequest", value: tx_9.MsgCreateMintRequest.fromPartial(data) }); },
                            msgSubmitVerifyCollectionOwner: function (data) { return ({ typeUrl: "/thesixnetwork.sixnft.nftoracle.MsgSubmitVerifyCollectionOwner", value: tx_10.MsgSubmitVerifyCollectionOwner.fromPartial(data) }); },
                        }];
            }
        });
    });
};
exports.txClient = txClient;
var queryClient = function (_a) {
    var _b = _a === void 0 ? { addr: "http://localhost:1317" } : _a, addr = _b.addr;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_c) {
            return [2 /*return*/, new rest_1.Api({ baseUrl: addr })];
        });
    });
};
exports.queryClient = queryClient;
